<template>
  <div class="orderby">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>海运下单页面</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容 -->
    <el-card class="main" style="margin-top:20px">
      <!-- 步骤条 -->
      <el-steps :active="active" finish-status="success">
        <el-step title="必填" description="此处信息必填哦，最快十秒内完成"></el-step>
        <el-step title="选填" description="生成唛头和入仓单，仓库优先装柜哦"></el-step>
        <el-step title="成功"></el-step>
      </el-steps>
      <el-alert
        v-if="lastDefaultsBannerVisible"
        class="last-defaults-banner"
        type="info"
        show-icon
        :closable="false"
        :title="'已按最近一票 ' + lastDefaultsOrderNo + ' 带入仓/报关/柜型/进口商'"
      >
        <el-button type="text" size="mini" @click="undoLastDefaults">撤销</el-button>
      </el-alert>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <!-- 必填 -->
        <div v-show="active==0">
          <!-- 基本信息 --> 
          <el-card class="activeOne">
            <div slot="header" class="clearfix">
              <b>
                <i class="el-icon-document"></i>基本信息
              </b> 
              <el-button type="primary" size="small" @click="downloadTemp">下载导入模版</el-button>
              <el-button type="primary" @click="openUploadDialog">导入订单</el-button>
            </div>
            <!-- 运单号 -->
            <div class="top">
              <div class="top-input">
                <div class="lable">运单编号:</div>
                <div class="field-control">
                  <el-form-item prop="topWaybill">
                    <el-input placeholder="可不填" v-model="ruleForm.topWaybill" type="text" maxlength="20"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="channel-toolbar">
              <div class="lable">筛选渠道:</div>
              <div class="channel-chips">
                <el-radio-group
                  v-model="channelFilterTransport"
                  size="mini"
                  @change="onChannelFilterChange"
                >
                  <el-radio-button label="all">全部</el-radio-button>
                  <el-radio-button label="01">海运</el-radio-button>
                  <el-radio-button label="02">空运</el-radio-button>
                </el-radio-group>
                <el-radio-group
                  v-model="channelFilterDelivery"
                  size="mini"
                  @change="onChannelFilterChange"
                >
                  <el-radio-button label="all">全部</el-radio-button>
                  <el-radio-button label="2">卡派</el-radio-button>
                  <el-radio-button label="1">快递</el-radio-button>
                </el-radio-group>
                <el-select
                  v-model="channelFilterCountry"
                  size="mini"
                  clearable
                  placeholder="目的国"
                  class="channel-filter-country"
                  @change="onChannelFilterChange"
                >
                  <el-option label="全部目的国" value="all" />
                  <el-option
                    v-for="opt in channelCountryFilterOptions"
                    :key="'cf-c-' + opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
                <el-radio-group
                  v-model="channelFilterDuty"
                  size="mini"
                  @change="onChannelFilterChange"
                >
                  <el-radio-button label="all">全部</el-radio-button>
                  <el-radio-button label="0">包税</el-radio-button>
                  <el-radio-button label="1">自税</el-radio-button>
                </el-radio-group>
                <el-radio-group
                  v-model="channelFilterClearance"
                  size="mini"
                  @change="onChannelFilterChange"
                >
                  <el-radio-button label="all">全部</el-radio-button>
                  <el-radio-button label="0">合单清</el-radio-button>
                  <el-radio-button label="1">单票单清</el-radio-button>
                </el-radio-group>
                <span class="channel-filter-hint">
                  已筛出 {{ filteredChannelCount }} 条
                  <template v-if="filteredChannelCount === 0">（无匹配，可换条件）</template>
                </span>
              </div>
            </div>
            <div class="top">
              <div class="top-input">
                <div class="lable">
                  <i class="bitian">*</i>渠道方式
                  <el-popover placement="top-start" width="260" trigger="click">
                    <p class="field-hint-text">支持搜索 EMC / 以星 / 美森 / 专线；可用上方筛选缩小范围。</p>
                    <i slot="reference" class="el-icon-question field-hint-icon" title="点击查看说明"></i>
                  </el-popover>
                  :
                </div>
                <div class="field-control">
                  <el-form-item prop="topChannel">
                    <el-select v-model="ruleForm.topChannel" clearable filterable placeholder="请选择渠道" @change="onChannelChange">
                      <el-option-group
                        v-for="group in filteredChannelData"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="(item,index) in group.options"
                          :key="item.id != null ? item.id : index"
                          :label="formatChannelOptionLabel(item)"
                          :value="item.id"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="top-input">
                <div class="lable">
                  报关方式
                  <el-popover placement="top-start" width="280" trigger="click">
                    <p class="field-hint-text">0110退税请向业务索取报关行代码并完成委托。特殊监管方式（9610/9710/9810/1039）请按实际出口模式选择。</p>
                    <i slot="reference" class="el-icon-question field-hint-icon" title="点击查看说明"></i>
                  </el-popover>
                  :
                </div>
                <div class="field-control">
                  <el-form-item>
                    <el-select v-model="ruleForm.topDeclare" placeholder="请选择" @change="topDe">
                      <el-option
                        v-for="item in ruleForm.declareData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                      <el-option-group label="特殊监管方式">
                        <el-option
                          v-for="item in ruleForm.declareSpecialData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="top-input">
                <div class="lable">
                  清关模式
                  <el-popover placement="top-start" width="280" trigger="click">
                    <p class="field-hint-text">由所选渠道决定。单票单清货可同柜，不能与合单清拼柜混装。</p>
                    <i slot="reference" class="el-icon-question field-hint-icon" title="点击查看说明"></i>
                  </el-popover>
                  :
                </div>
                <div class="field-control">
                  <el-form-item>
                    <el-input :value="clearanceModeLabel" disabled placeholder="请先选择渠道"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="top-input">
                <div class="lable">承运方式:</div>
                <div class="field-control">
                  <el-form-item>
                    <el-cascader
                      v-model="ruleForm.topOcean"
                      :options="ruleForm.oceanData"
                      @change="oceanShip"
                      :props="{ value: 'name', label: 'name'}"
                      placeholder="请选择"
                    ></el-cascader>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="place-group">
              <div class="top">
                <!-- 送货地 -->
                <div class="top-input">
                <div class="lable">
                  <i class="bitian">*</i>送货仓库
                  <el-popover placement="top-start" width="260" trigger="click">
                    <p class="field-hint-text">请选择货物送往的国内收货仓；选定后可再填预计到仓时间。</p>
                    <i slot="reference" class="el-icon-question field-hint-icon" title="点击查看说明"></i>
                  </el-popover>
                  :
                </div>
                <div class="field-control">
                  <el-form-item prop="cenPlace">
                    <el-select
                      v-model="ruleForm.cenPlace"
                      placeholder="请选择"
                      @change="cenPl"
                      :disabled="dispatchSelectDisabled"
                    >
                      <el-option-group
                        v-for="group in displayPlaceData"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="(item,index) in group.options"
                          :key="index"
                          :label="item.cname"
                          :value="item.cname"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <!-- 送货时间 -->
              <div class="top-input">
                <div class="lable">
                  <i class="bitian">*</i>送货时间
                  <el-popover placement="top-start" width="240" trigger="click">
                    <p class="field-hint-text">预计到仓时间，方便仓库安排人员收货。</p>
                    <i slot="reference" class="el-icon-question field-hint-icon" title="点击查看说明"></i>
                  </el-popover>
                  :
                </div>
                <div class="field-control">
                  <el-form-item prop="dispatchTime">
                    <el-date-picker
                      v-model="ruleForm.dispatchTime"
                      type="date"
                      placeholder="选择日期"
                      @change="dispatchTime"
                      :picker-options="pickerOptions"
                      value-format="timestamp"
                      format="yyyy-MM-dd"
                      :disabled="ruleForm.cenPlace==''"
                    ></el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <!-- 进口商：默认禁用；仅渠道「单票单清」时可改，可选公司/客户自有进口商 -->
              <div class="top-input">
                <div class="lable">
                  进口商
                  <el-popover placement="top-start" width="260" trigger="click">
                    <p class="field-hint-text">合单清固定使用公司进口商；单票单清时可改选客户自己的进口商。</p>
                    <i slot="reference" class="el-icon-question field-hint-icon" title="点击查看说明"></i>
                  </el-popover>
                  :
                </div>
                <div class="field-control">
                  <el-form-item>
                    <el-select
                      v-model="ruleForm.cenImported"
                      placeholder="请选择"
                      @change="cen"
                      :disabled="!importerSelectEnabled"
                    >
                      <el-option label="公司进口商" :value="1"></el-option>
                      <el-option
                        v-for="(item,index) in ruleForm.importedData"
                        :key="index"
                        :label="formatImporterOptionLabel(item)"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <!-- 发货人 -->
              <div class="top-input">
                <div class="lable">发货人:</div>
                <div class="field-control">
                  <el-form-item>
                    <el-select v-model="ruleForm.cenDeliver" placeholder="请选择" @change="cenDe" disabled id="jinkoushang">
                      <el-option
                        v-for="(item,index) in ruleForm.deliverData"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              </div>
              <div class="field-extra field-extra--line" v-if="dispatchHintText">{{ dispatchHintText }}</div>
            </div>
            <!-- radio -->
            <div class="radio">
              <div class="radio-bar">
                <div class="lable"><i class="bitian">*</i>目的仓:</div>
                <el-radio-group @change="radioVal" v-model="radio">
                  <el-radio :label="0" v-show="orderType0">FBA地址</el-radio>
                  <el-radio :label="1" v-show="orderType1">私人地址</el-radio>
                  <el-radio :label="2" v-show="orderType2">三方仓</el-radio>
                  <el-radio :label="3" v-show="orderType3">留仓</el-radio>
                  <el-radio :label="4" v-show="orderType4">传统</el-radio>
                  <el-radio :label="5" v-show="orderType5">一件代发</el-radio>
                </el-radio-group>
              </div>
              <div class="radio-body">
                <!-- FBA地址 -->
                <div v-show="radio==0" class="radio-row">
                  <div class="lable">仓库代码:</div>
                  <div class="field-control field-control--sm">
                    <el-form-item prop="wareCode">
                      <el-select
                        class="wareselect"
                        v-model="ruleForm.wareCode"
                        filterable
                        placeholder="请选择"
                        @change="wareDataAddress"
                      >
                        <el-option
                          v-for="(item,index) in ruleForm.wareData"
                          :key="index"
                          :label="item.lable"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <i class="el-icon-location-information radio-addr" v-if="addressInfo" v-html="safeAddressInfo"></i>
                </div>
                <!-- 私人地址：四列网格，与上方基本信息对齐 -->
                <div v-show="radio==1" class="radio-grid">
                  <div class="radio-row">
                    <div class="lable">国家:</div>
                    <div class="field-control">
                      <el-form-item prop="country">
                        <country
                          class="country"
                          placeholder="请输入国家"
                          :countrys="ruleForm.country"
                          @getCty="getCountry"
                        ></country>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="radio-row">
                    <div class="lable">收件人:</div>
                    <div class="field-control">
                      <el-form-item prop="addressee">
                        <el-input placeholder="请输入收件人" v-model="ruleForm.addressee"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="radio-row">
                    <div class="lable">州:</div>
                    <div class="field-control">
                      <el-form-item prop="state">
                        <el-input placeholder="请输入州" v-model="ruleForm.state"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="radio-row">
                    <div class="lable">邮编:</div>
                    <div class="field-control">
                      <el-form-item prop="addzip">
                        <el-input placeholder="请输入邮编" v-model="ruleForm.addzip"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="radio-row">
                    <div class="lable">联系电话:</div>
                    <div class="field-control">
                      <el-form-item prop="telPhone">
                        <el-input placeholder="请输入联系电话" v-model="ruleForm.telPhone"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="radio-row radio-row--wide">
                    <div class="lable">地址:</div>
                    <div class="field-control">
                      <el-form-item prop="address">
                        <el-input placeholder="请输入详细地址" type="textarea" :rows="2" v-model="ruleForm.address"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <!-- 三方仓 -->
                <div v-show="radio==2" class="radio-row">
                  <div class="lable">仓库代码:</div>
                  <div class="field-control field-control--sm">
                    <el-form-item prop="whCode">
                      <el-select
                        class="wareselect"
                        v-model="ruleForm.whCode"
                        filterable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item,index) in ruleForm.whData"
                          :key="index"
                          :label="item.lable"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <!-- 留仓 -->
                <div v-show="radio==3" class="radio-row">
                  <div class="lable">留仓代码:</div>
                  <div class="field-control field-control--sm">
                    <el-form-item prop="whHoldCode">
                      <el-select
                        class="wareselect"
                        v-model="ruleForm.whHoldCode"
                        filterable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item,index) in ruleForm.whHoldData"
                          :key="index"
                          :label="item.lable"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <!-- 传统 -->
                <div v-show="radio==4" class="radio-row">
                  <div class="lable">传统:</div>
                  <div class="field-control field-control--sm">
                    <el-form-item prop="endPort">
                      <el-select
                        class="wareselect"
                        v-model="ruleForm.endPort"
                        filterable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item,index) in ruleForm.endPortList"
                          :key="index"
                          :label="item.portChinese +'/'+ item.portEnglish +'/'+ item.portFive"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <!-- 一件代发 -->
                <div v-show="radio==5" class="radio-row">
                  <div class="lable">一件代发:</div>
                  <div class="field-control field-control--sm">
                    <el-form-item prop="wholesaleCode">
                      <el-select
                        class="wareselect"
                        v-model="ruleForm.wholesaleCode"
                        filterable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item,index) in ruleForm.wholesaleData"
                          :key="index"
                          :label="item.lable"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
          <!-- 产品申报 -->
          <el-card class="activeOne">
            <div slot="header" class="clearfix">
              <div style="line-height:32px">
                <b>
                  <i class="el-icon-document"></i>产品申报
                </b>
              </div>
              <el-link style="margin-left:20px" type="primary" icon="el-icon-download" :href="apiAction(0)">下载产品模板</el-link>
            </div>
            <div class="product" style="overflow: hidden;">
              <el-upload
                class="upload-demo"
                drag
                :action="apiAction(1)"
                multiple
                :headers="myHeaders"
                :before-upload="refreshUploadToken"
                :on-success="handProduct"
                :on-remove="handRemove"
                :limit="1"
                name="upload"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
              </el-upload>
            </div>
            <div style="margin-top:20px">
              <el-alert
                v-if="goodsRiskHit"
                type="warning"
                show-icon
                :closable="false"
                title="品名合规提示：部分品名可能涉及敏感/管制货，仅提醒不拦截，请如实申报并准备许可材料。"
                style="margin-bottom:10px"
              />
              <div class="tips">
                <span>总数量：{{ qty }}</span>
                <span>总申报价值：{{ totalValue }}</span>
              </div>
              <el-table size="mini" :data="ruleForm.master_userArr" border style="width: 100%">
                <el-table-column align='center' fixed>
                  <template slot="header">
                    <el-link
                      type="primary"
                      size="mini"
                      :underline="false"
                      icon="el-icon-circle-plus-outline"
                      @click="addRow">添加</el-link>
                  </template>
                  <template slot-scope="scope">
                    <!-- <span
                      class="el-tag el-tag--danger el-tag--mini"
                      style="cursor: pointer;"
                      @click="deleteRow(scope.$index,ruleForm.master_user.data,ruleForm.master_userArr)"
                    ></span> -->
                    <el-link
                      type="danger"
                      size="mini"
                      :underline="false"
                      @click="deleteRow(scope.$index,ruleForm.master_user.data,ruleForm.master_userArr)"
                    >移除</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="中文名" width="120" :render-header="renderHeader" fixed>
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.name" @blur="scheduleGoodsRiskCheck"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="英文名" width="120"  :render-header="renderHeader" fixed>
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.ename" @blur="scheduleGoodsRiskCheck"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="合规提示" width="140" fixed>
                  <template slot-scope="scope">
                    <el-tooltip v-if="scope.row._riskHit" :content="scope.row._riskTip || '敏感品名，请人工复核'" placement="top">
                      <div>
                        <el-tag
                          v-for="(lb, ti) in (scope.row._riskLabels || [])"
                          :key="ti"
                          type="danger"
                          size="mini"
                          style="margin:1px"
                        >{{ lb }}</el-tag>
                      </div>
                    </el-tooltip>
                    <span v-else style="color:#c0c4cc">—</span>
                  </template>
                </el-table-column>
                <el-table-column label="材质" width="120" :render-header="renderHeader">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.material"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="用途" width="120" :render-header="renderHeader" >
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.purpose"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="报关编码HS" width="120" :render-header="renderHeader">
                  <template slot-scope="scope">
                      <el-input placeholder="请输入" v-model="scope.row.hscode"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="清关编码" width="120" >
                  <template slot-scope="scope">
                      <el-input placeholder="请输入" v-model="scope.row.gwcode"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="税率" width="120" >
                  <template slot-scope="scope">
                      <el-input placeholder="请输入" v-model="scope.row.taxRate"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="带电带磁" width="120">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.electrificationState" clearable placeholder="请选择">
                      <el-option
                        v-for="item in ruleForm.master_user.eleData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.brand"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="品牌类型" width="180">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.brandType" clearable placeholder="请选择">
                      <el-option
                        v-for="item in ruleForm.master_user.btData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="型号" width="120" :render-header="renderHeader" >
                  <template slot-scope="scope">
                      <el-input placeholder="请输入" v-model="scope.row.model"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="件数" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入" v-model="scope.row.ctn"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.ctn"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="数量" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入" v-model="scope.row.qty"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.qty"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="USD单价" :render-header="renderHeader" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入" v-model="scope.row.unitValue"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.unitValue"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="申报总价" :render-header="renderHeader" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入申报总价" v-model="scope.row.totalValue"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.totalValue"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="净重" :render-header="renderHeader" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入" v-model="scope.row.nkg"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.nkg"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="实重" :render-header="renderHeader" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入实重" v-model="scope.row.kg"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.kg"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="尺寸"  :render-header="renderHeader" width="150">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.size"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="总体积"  :render-header="renderHeader" width="120">
                  <template slot-scope="scope">
                    <!-- <el-input placeholder="请输入总体积" v-model="scope.row.cbm"></el-input> -->
                    <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="scope.row.cbm"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="唛头序号" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.markNo"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="产品标" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.fnsku"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="链接" width="120">
                  <template slot-scope="scope">
                    <el-input placeholder="请输入" v-model="scope.row.selleLink"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="图片" :render-header="renderHeader" >
                  <template slot-scope="scope">
                    <el-upload
                      name="upload"
                      style="text-align:center"
                      :action="apiAction(2)"
                      :show-file-list="false"
                      :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList, scope.$index)"
                      :before-upload="beforeUpload"
                      :file-list="fileList"
                      list-type="picture"
                      :headers="myHeaders"
                    >
                      <el-button v-if="!scope.row.picUrl" type="text">
                        上传<i class="el-icon-upload el-icon--right"></i>
                      </el-button>
                      <img v-else style="width:100%" :src="scope.row.picUrl" />
                    </el-upload>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top:20px">
              <el-button type="primary" @click="addList">添加已有产品</el-button>
              <el-dialog
                title="添加已有产品"
                :visible.sync="dialogVisible"
                center>
                <el-table
                :data="productData"
                @selection-change="selectData"
                ref="multipleTable"
                @row-click="handleRowClick"
                style="width: 100%">
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column label="产品图" prop="picUrl">
                    <template slot-scope="scope">
                      <el-image :src="scope.row.picUrl" style="width:50px"></el-image>
                      </template>
                  </el-table-column>
                  <el-table-column label="中文名称" prop="name"></el-table-column>
                  <el-table-column label="英文名称" prop="ename"></el-table-column>
                  <el-table-column label="产品SKU" prop="sku"></el-table-column>
                  <el-table-column label="型号" prop="model"></el-table-column>                  
                  <!-- <el-table-column label="报关编码" prop="hscode"></el-table-column>
                  <el-table-column label="材质" prop="material"></el-table-column>
                  <el-table-column label="用途" prop="purpose"></el-table-column> -->
                  <el-table-column label="尺寸" prop="size" ></el-table-column>
                  <!-- <el-table-column label="品牌" prop="brand"></el-table-column> -->
                  <el-table-column label="链接" prop="selleLink" width="120"></el-table-column>
                  <el-table-column label="国家" prop="country" ></el-table-column>
                  <!-- <el-table-column label="销售价" prop="price" ></el-table-column> -->

                </el-table>
                <div class="block" style="margin-top:20px;text-align:center">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 40,60, 80,100]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                  ></el-pagination>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="add">确 定</el-button>
                </span>
              </el-dialog>
            </div>
          </el-card>
          <!-- 预约号 -->
          <el-card class="activeOne" v-show="radio==0">
            <div slot="header" class="clearfix">
              <div style="line-height:32px">
                <b>
                  <i class="el-icon-document"></i>预约号/货件ID
                </b>
              </div>
              <!-- <el-link style="margin-left:20px" type="primary" icon="el-icon-download" >导入ID</el-link> -->

              <el-upload
                class="upload-demo"
                :action="apiAction(3)"
                :headers="myHeaders"
                :before-upload="refreshUploadToken"
                :on-success="handShipmentId"
                :show-file-list="noList"
                 multiple
                :limit="1"
                name="upload">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
                <span style="margin-left: 10px;margin-top: 10px;">当前预约号条数： {{  ruleForm.order_user.length }}</span>
               <el-link style="margin-left:20px" type="primary" icon="el-icon-download" :href="apiAction(4)">下载预约号模板</el-link>
            </div>
            <div class="subScribe">
              <table class="gridtable">
                <thead>
                  <tr>
                    <th>
                      <el-button class="th" type="text" size="mini" @click="insert" icon="el-icon-circle-plus-outline">添加</el-button>
                    </th>
                    <th>
                      <span class="th">跟踪号/FBA</span>
                    </th>
                    <th>
                      <span class="th">内部跟踪号</span>
                    </th>
                    <th>
                      <span class="th">件数CTN</span>
                    </th>
                    <th>
                      <span class="th">重量KGS</span>
                    </th>
                    <th>
                      <span class="th">体积CBM</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user,index) in ruleForm.order_user" :key="index">
                    <td style="text-align:center">
                      <el-link
                        type="danger"
                        size="mini"
                        :underline="false"
                        @click="remove(index)"
                      >移除</el-link>
                    </td>
                    <td>
                      <el-input size="mini" v-model="user.shipmentid" title="亚马逊后台建立的货件号，还未有货件填1补充" placeholder="shipment id"/>
                    </td>
                    <td>
                      <el-input size="mini" v-model="user.referenceid" placeholder="reference id"/>
                    </td>
                    <td>
                      <el-input size="mini" v-model="user.ctn" />
                    </td>
                    <td>
                      <!-- <el-input size="mini" v-model="user.kg.toFixed(2)" /> -->
                      <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.kg"></el-input-number>
                    </td>
                    <td>
                      <!-- <el-input size="mini" v-model="user.cbm.toFixed(2)" /> -->
                      <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.cbm"></el-input-number>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-card>
          <!-- 下一步 -->
          <el-form-item style="margin-top: 20px;text-align: center">
            <el-button type="primary" size="medium" @click="next('ruleForm')">下一步<i class="el-icon-arrow-right el-icon--right"/></el-button>
          </el-form-item>
        </div>
        <!-- 选填 -->
        <div v-show="active==1">
          <el-card class="activeTwo">
            <div slot="header" class="clearfix">
              <b>
                <i class="el-icon-document"></i>增值服务
              </b>
            </div>
            <div class="switch">
              <div class="sw_cent">
                <div class="label" style="margin-right: 10px">
                  <span>是否提货</span>
                </div>
                <el-switch v-model="takeVal" @change="take"></el-switch>
              </div>
              <div class="sw_cent">
                <div class="label" style="margin-right: 10px">
                  <span>购买保险</span>
                </div>
                <el-switch v-model="InsuranceVal" @change="Insurance"></el-switch>
              </div>
            </div>
            <div class="take" v-show="takeVal">
              <div class="take-cent">
                <div>
                  <span><i class="red">*</i> 取货信息:</span>
                  <el-input v-model="factoryVal" placeholder="请输入xxx工厂"></el-input>
                  <el-input v-model="telVal" placeholder="请输入电话"></el-input>
                </div>
                <div class="take-time">
                  <span><i class="red">*</i> 取货时间:</span>
                  <el-date-picker
                    v-model="creteTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    @change="pickTime"
                    :picker-options="pickerOptions"
                    default-time="12:00:00"
                    format="yyyy-MM-dd HH:mm">
                  </el-date-picker>
                </div>
                <div>
                  <span><i class="red">*</i> 取货地址:</span>
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="addressVal"></el-input>
                </div>
                <div>
                  <span>取货备注:</span>
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ramakVal"></el-input>
                </div>
              </div>
            </div>
            <div class="insurance" v-show="InsuranceVal">
              <div>
                <span><i class="red">*</i> 公司名称:</span>
                <el-input v-model="insurancePeople" placeholder="请输入您的公司全称"></el-input>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="保险额度:不能超过真实成本的110%，保险费用按保额的千分之五收取，优惠咨询业务"
                  placement="top-start"
                >
                  <el-tag type="warning">!</el-tag>
                </el-tooltip>
                <span><i class="red">*</i> 保险额度:</span>
                <el-input v-model="insuranceQuota" placeholder="请输入额度"></el-input>
                <span><i class="red">*</i> 保险币种:</span>
                <el-select
                  v-model="insuranceCurrency"
                  filterable
                  clearable
                  placeholder="请选择币种"
                  size="small"
                >
                  <el-option
                    v-for="(item,index) in insuranceCurrencys"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <span><i class="red">*</i> 上架保障:</span>
                <el-select
                  v-model="shelf"
                  filterable
                  clearable
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="(item,index) in shelfList"
                    :key="index"
                    :disabled="item.disabled"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="remake">
              <span >备注:</span>
              <el-input 
              v-model="ruleForm.inputValue" 
              placeholder="费用报价/特殊要求/船期保舱/ASIN链接/VAT"
              type="textarea"
              :rows="3"
              ></el-input>
              <div class="tag">
                <el-tag
                  :key="tag"
                  v-for="tag in dynamicTags"
                  size="small"
                  @click="getTag(tag)"
                >{{tag}}</el-tag>
              </div>
            </div>
          </el-card>
          <!-- 下一步 -->
          <el-form-item style="margin-top: 20px;text-align: center">
            <el-button type="" size="medium" @click="formNext" icon="el-icon-arrow-left">上一步</el-button>
            <el-button type="primary" size="medium" :loading="submitting" :disabled="submitting" @click="submitForm" icon="el-icon-check">立即创建</el-button>
          </el-form-item>
        </div>
        <!-- 生成订单 -->
        <div v-show="active==2">
          <el-card class="activeThree">
            <!-- <div>
              <el-button type="primary" @click="getMaitou" icon="el-icon-download">唛头</el-button>
              <span style="margin-left:20px">唛头每箱货贴一张</span>
            </div> -->
            <div>
              <el-button type="success" icon="el-icon-download" @click="getMaitou" >下载唛头</el-button>
              <span style="margin-left:20px"><b>唛头：</b>每箱货贴一张，方便分货，优先装柜，优先派送</span><span style="color:red">（代贴：1元/箱）</span>
            </div>
            <div>
              <el-button type="primary" @click="getRucangdan" icon="el-icon-download">入仓单</el-button>
              <span style="margin-left:20px"><b>入仓单：</b>打印一份，由司机带进仓库，作为入仓登记。</span><span style="color:red">（代打：10元/张）</span>
            </div>
            <div>
              <el-button type="success" @click="toNext">订单完成</el-button>
            </div>
          </el-card>
        </div>
      </el-form>
    </el-card>
    <el-dialog
      class="abnormal"
      title="唛头下载"
      :visible.sync="dialogFormVisible3"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="35%"
    >
      <div class="dialog-footer" style="text-align:center;">
        <el-select v-model="marks" clearable placeholder="请选择唛头模板" value-key="id">
          <el-option
            v-for="(item,index) in options3"
            :key="index"
            :label="item.marks"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="getMaitou2()">单张唛头</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="abnormal"
      title="送货时间"
      :visible.sync="dialogFormVisible4"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="640px"
      center
    >
      <div class="dialog-footer" style="text-align:center;">
        <el-row :gutter="20" style="margin:0;">
            <el-col :span="20">
              <el-date-picker
                v-model="ruleForm.dispatchTime"
                type="date"
                placeholder="选择日期"
                @change="dispatchTime"
                :picker-options="pickerOptions"
                value-format="timestamp"
                format="yyyy-MM-dd"
                style="width:100%;border-radius: 0;"
              ></el-date-picker>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" style="width:100%;border-radius: 0;" @click="dialogFormVisible4 = false">确 认</el-button>
            </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <div style="width:600px;">
          <el-row :gutter="20" style="margin:0;">
            <el-col :span="6">
              <el-button type="text"  @click="setTime(8)" :disabled="isDisabled('08')" class="grid-content bg-purple">8:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(9)" :disabled="isDisabled('09')" class="grid-content bg-purple">9:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(10)" :disabled="isDisabled('10')" class="grid-content bg-purple">10:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(11)" :disabled="isDisabled('11')" class="grid-content bg-purple">11:00</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin:0;">
            <el-col :span="6">
              <el-button type="text"  @click="setTime(13)" :disabled="isDisabled('13')" class="grid-content bg-purple">13:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(14)" :disabled="isDisabled('14')" class="grid-content bg-purple">14:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(15)" :disabled="isDisabled('15')" class="grid-content bg-purple">15:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(16)" :disabled="isDisabled('16')" class="grid-content bg-purple">16:00</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin:0;">
            <el-col :span="6">
              <el-button type="text"  @click="setTime(17)" :disabled="isDisabled('17')" class="grid-content bg-purple">17:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(18)" :disabled="isDisabled('18')" class="grid-content bg-purple">18:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(19)" :disabled="isDisabled('19')" class="grid-content bg-purple">19:00</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="text"  @click="setTime(20)" :disabled="isDisabled('20')" class="grid-content bg-purple">20:00</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
   <!-- 新增：导入订单上传弹窗 -->
  <el-dialog
    title="导入订单"
    :visible.sync="dialogUploadVisible"
    width="500px"
    center
  >
    <div class="upload-container">
      <el-upload
        class="upload-drag"
        drag
        :action="uploadApi"  
        :headers="myHeaders"  
        :on-success="handleUploadSuccess"  
        :on-error="handleUploadError"  
        :before-upload="beforeOrderUpload" 
        :file-list="uploadFileList"
        :limit="1"
        :on-exceed="handleExceed"
        name="file"  
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          支持扩展名：.xlsx, .xls<br>
          单个文件大小不超过10MB
        </div>
      </el-upload>
    </div>
    <span slot="footer">
      <el-button @click="dialogUploadVisible = false">取消</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
// 注意：不要在这里取 token。本文件由 router/orderevent.js 静态 import，模块体在应用启动时
// （还在登录页时就）求值一次，那时 sessionStorage 里还没有 token，快照会一直是 null，
// 导致本页 el-upload（原生 XHR 不走 axios 拦截器）带的 token 恒为空 → 后端 40100「token校验失败」。
// 上传 token 一律走 data 里的 myHeaders + 上传前 refreshUploadToken() 实时取。
//引入api
import httpApi from "@/http/api"
import apiCfg from "../../../config"
import { applyGoodsRiskToRows, buildGoodsRiskConfirmLines } from "@/utils/goodsRisk"
import { sanitizeHtml } from "@/utils/sanitizeHtml"
import { formatImporterOptionLabel } from "@/utils/importerTax"
//引入组件
import Country from "@/components/Country";
export default {
  components: {
    Country
  },
  data() {
    // 自定义校验
    var checkClientNo = (rule, value, callback) => {
      if (!value || !String(value).trim()) {
        return callback();
      }
      const regClientNo = /^\s*\S+\s*$/;
      if (regClientNo.test(value)) {
        return callback();
      }
      return callback(new Error("运单号中间不能有空格，可用-代替空格"));
    };
    return {
      goodsRiskHit: false,
      _goodsRiskTimer: null,
      lastDefaultsBannerVisible: false,
      lastDefaultsOrderNo: "",
      lastDefaultsSnapshot: null,
      _lastDefaultsReqSeq: 0,
      channelFilterTransport: "all",
      channelFilterDelivery: "all",
      channelFilterCountry: "all",
      channelFilterDuty: "all",
      channelFilterClearance: "all",
      selectedClearanceMode: "",
      countryLabelMap: {
        US: "美国",
        JP: "日本",
        CA: "加拿大",
        MX: "墨西哥",
        BR: "巴西",
        EU: "欧洲",
        GB: "英国",
        UK: "英国",
        DE: "德国",
        FR: "法国",
        AU: "澳洲"
      },
      submitting: false,
      responseDataUp: null,
      orderType0: true,
      orderType1: true, 
      orderType2: true,
      orderType3: true,
      orderType4: true,
      orderType5: true,
      noList: false,
      dialogUploadVisible: false,
      uploadFileList: [],
      uploadApi:apiCfg.portalApi+"order/import",
      myHeaders: { token: sessionStorage.getItem("token") || "" },
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      day:"",
      timeData: [],
      options3: [],
      marks: {},
      fileList: [], //上传图片列表
      rules: {
        topWaybill: [
          { validator: checkClientNo, trigger: "blur" }
        ],
        topChannel: [
          { required: true, message: "请选择渠道方式", trigger: "change" }
        ],
        wareCode: [
          { required: true, message: "请选择仓库代码", trigger: "change" }
        ],
        whCode: [
          { required: false, message: "请选择自提代码", trigger: "change" }
        ],
        whHoldCode:[
          { required: false, message: "请选择留仓代码", trigger: "change" }
        ],
        endPort:[
          { required: false, message: "请选择传统代码", trigger: "change" }
        ],
        wholesaleCode:[
          { required: false, message: "请选择一件代发代码", trigger: "change" }
        ],
        country: [
          { required: false, message: "请选择国家", trigger: "change" }
        ],
        addressee: [
          { required: false, message: "请输入收件人", trigger: "blur" }
        ],
        state:[
          { required: false, message: "州必填", trigger: "blur" }
        ],
        addzip:[
          { required: false, message: "邮编必填", trigger: "blur" }
        ],
        telPhone: [
          { required: false, message: "请输入电话", trigger: "blur" }
        ],
        address: [
          { required: false, message: "请输入地址", trigger: "blur" }
        ],
        cenPlace: [
          { required: true, message: "请选择送仓地", trigger: "change" }
        ], //送货地
        dispatchTime: [
          { required: true, message: "请选择送货时间", trigger: "blur" }
        ]
      },
      qty: "0",
      totalValue: "0",
      ruleForm: {
        topWaybill: "", //运单编号
        topChannel: "", //渠道方式
        channelData: [],
        topDeclare: "0", //报关方式
        topDeclVal: "0",
        declareData: [
          { label: "买单", value: "0" },
          { label: "0110退税", value: "1" },
          { label: "自拖自报", value: "3" },
          { label: "合并报关", value: "4" }
        ],
        declareSpecialData: [
          { label: "9610报关", value: "8" },
          { label: "9710报关", value: "9" },
          { label: "9810报关", value: "10" },
          { label: "1039市场采购", value: "11" }
        ],
        topOcean: ["拼柜"], //承运方式（拼柜/整柜）
        oceanData: [
          {
            id: "0",
            name: "拼柜"
          },
          {
            id: "1",
            name: "整柜",
            children: []
          }
        ],
        topOceanNum: "0", //拼柜整柜
        topOceanType: "", //整柜类型
        cenPlace: "", //送货地
        cenId: "", //送货地id
        placeData: [],
        cenPlaceText: "", //送货名字
        dispatchTime: "", //送货时间
        cenDeliver: "", //发货人
        cenDelivertext: "", //发货人名字
        deliverData: [],
        cenImported: "", //进口商
        cenImporVal: "1", //进口商默认
        cenImportext: "", //显示名字
        cenImporValue: "", //进口商参数
        importedData: [],
        wareCode: "", //仓库代码
        wareData: [],
        whCode: "", //自提
        whData: [], //自提货数据
        whHoldCode: "", //留仓
        whHoldData: [], //留仓数据
        endPort: "",
        endPortList: [],
        wholesaleCode: "", //一件代发
        wholesaleData: [], //一件代发数据
        country: "", //国家
        addressee: "", //收件人
        state: "",//州
        addzip:"",//私人地址邮编
        telPhone: "", //联系电话
        address: "", //详细地址
        inputValue: "", //备注
        quoteFeeList: [], //查价快速下单费用快照
        master_user: {
          sel: null, //选中行EW
          eleData: [
            { label: "否", value: "0" },
            { label: "只带电", value: "1" },
            { label: "只带磁", value: "2" },
            { label: "带电带磁", value: "3" }
          ],
          btData: [
            { label: "无品牌", value: "0" },
            { label: "境内自主品牌", value: "1" },
            { label: "境内收购品牌", value: "2" },
            { label: "境外品牌(贴牌生产)", value: "3" },
            { label: "境外品牌(其他)", value: "4" }
          ],
          data: []
        },
        master_userArr: [],
        order_user: [
          { shipmentid: "", referenceid: "", ctn: 0, kg: 0, cbm: 0 }
        ],
        order_userArr: {
          shipmentid: "",
          referenceid: "",
          ctn: "",
          kg: "",
          cbm: ""
        },
      },
      active: 0, //步骤条
      radio: 5, //地址
      textVal: "", //送货仓（不再展示真址）
      dispatchHintText: "",
      dispatchSelectDisabled: false,
      channelDispatchOptionIds: null, // null=全部仓；数组=限制可选仓ID
      addressInfo: "", //代码地址
      dynamicTags: [], //备注
      //选题
      takeVal: false, //需要提货
      pickupType: "0", //提货0-1
      pickObj: {},
      pickupList: [], //提货参数
      InsuranceVal: false, //需要保险
      insurance: "0", //保险0-1
      insuranceCurrency: "",//保险币种
      insuranceCurrencys: [
        {label:"人民币",value:"CNY"},
        {label:"美元",value:"USD"},
        {label:"欧元",value:"EUR"},
        {label:"英镑",value:"GBP"},
        {label:"港元",value:"HKD"}
      ],
      shelf: "",
      shelfList: [
        {key:"不保上架",value:"NONE",disabled:false},
        {key:"保上架(整箱)",value:"FCL",disabled:false},
        {key:"保上架(整箱/单个)",value:"SINGLE",disabled:true},
        {key:"只保上架(整箱)",value:"ONLY_FCL",disabled:false},
        {key:"只保上架(单个)",value:"ONLY_SINGLE",disabled:true},
      ],
      factoryVal: "", //工厂
      telVal: "",
      creteTime: "", //取货时间
      addressVal: "", //地址
      ramakVal: "", //备注
      insurancePeople: "", //保险人
      insuranceQuota: "", //保险额度
      orderVal: "", //成功生成得订单号
      //复制下单
      copyData: {}, //复制订单详情
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        }
      },
      imageUrl: '',
      goodsNullList: {
        name: "",
        ename: "",
        material: "",
        purpose: "",
        hscode: "",
        gwcode: "",
        taxRate: "",
        electrificationState: "0",
        brand: "无",
        brandType: "0",
        model: "无",
        ctn: 1,
        qty: 0.00,
        unitValue: "",
        totalValue: "",
        nkg: "",
        kg: "",
        size: "",
        cbm: "",
        picUrl: ""
      },
      dialogVisible: false,
      productData: [], //产品列表
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      inputVal: "",
      selectDatas: "",
    };
  },
  computed: {
    safeTextVal() {
      return sanitizeHtml(this.textVal)
    },
    safeAddressInfo() {
      return sanitizeHtml(this.addressInfo)
    },
    displayPlaceData() {
      const groups = this.ruleForm.placeData || [];
      const ids = this.channelDispatchOptionIds;
      // 对客只展示仓名 cname（不再拼城市）
      if (!ids || !ids.length) {
        return groups;
      }
      const idSet = new Set(ids.map(Number));
      return groups
        .map(g => ({
          ...g,
          options: (g.options || []).filter(o => idSet.has(Number(o.id)))
        }))
        .filter(g => g.options && g.options.length);
    },
    filteredChannelData() {
      const transport =
        this.channelFilterTransport === "all" ? "" : this.channelFilterTransport;
      const delivery =
        this.channelFilterDelivery === "all" ? "" : this.channelFilterDelivery;
      const country =
        this.channelFilterCountry === "all" || !this.channelFilterCountry
          ? ""
          : String(this.channelFilterCountry).trim().toUpperCase();
      const duty =
        this.channelFilterDuty === "all" ? "" : this.channelFilterDuty;
      const clearance =
        this.channelFilterClearance === "all" ? "" : this.channelFilterClearance;
      const groups = this.ruleForm.channelData || [];
      if (!transport && !delivery && !country && !duty && !clearance) {
        return groups;
      }
      return groups
        .map(group => ({
          label: group.label,
          options: (group.options || []).filter(item =>
            this.channelMatchesFilters(
              item,
              transport,
              delivery,
              country,
              duty,
              clearance
            )
          )
        }))
        .filter(group => group.options.length > 0);
    },
    clearanceModeLabel() {
      if (!this.ruleForm.topChannel) return "";
      if (this.selectedClearanceMode === "1") return "单票单清";
      if (this.selectedClearanceMode === "0") return "合单清";
      return "合单清";
    },
    /** 仅单票单清可改进口商；合单清/未选渠道均禁用 */
    importerSelectEnabled() {
      return this.selectedClearanceMode === "1";
    },
    filteredChannelCount() {
      return this.filteredChannelData.reduce(
        (sum, group) => sum + ((group.options && group.options.length) || 0),
        0
      );
    },
    channelCountryFilterOptions() {
      const codes = new Set();
      (this.ruleForm.channelData || []).forEach(group => {
        (group.options || []).forEach(item => {
          const code = String((item && item.country) || "")
            .trim()
            .toUpperCase();
          if (code) codes.add(code);
        });
      });
      return Array.from(codes)
        .sort()
        .map(code => ({
          value: code,
          label: this.formatCountryLabel(code)
        }));
    }
  },
  methods: {
    resolveChannelTransport(item) {
      const type = String((item && item.channelType) || "").trim();
      if (type === "空运" || type.indexOf("空运") >= 0) return "02";
      if (type === "海运" || type.indexOf("海运") >= 0) return "01";
      const name = String((item && item.name) || "");
      if (/空运|空派|空卡|直飞/.test(name) && !/海运|海卡|海派|快船/.test(name)) {
        return "02";
      }
      if (/海运|海卡|海派|快船/.test(name) && !/空运|空派|空卡|直飞/.test(name)) {
        return "01";
      }
      const code = String((item && item.transportModeCode) || "").trim();
      if (code === "02") return "02";
      if (code === "01" || code === "0") return "01";
      return "";
    },
    resolveChannelDelivery(item) {
      const code = String((item && item.deliverywayCode) || "").trim();
      if (code === "1" || code === "2") return code;
      const name = String((item && item.name) || "");
      if (/快递|空派|海派|UPS|黑猫|佐川/.test(name) && !/卡派|海卡|卡车/.test(name)) {
        return "1";
      }
      if (/卡派|海卡|卡车|整柜/.test(name)) return "2";
      return "";
    },
    channelMatchesFilters(item, transport, delivery, country, duty, clearance) {
      if (transport) {
        const resolved = this.resolveChannelTransport(item);
        if (resolved !== transport) return false;
      }
      if (delivery) {
        const resolved = this.resolveChannelDelivery(item);
        if (resolved !== delivery) return false;
      }
      if (country) {
        const itemCountry = String((item && item.country) || "")
          .trim()
          .toUpperCase();
        if (itemCountry !== country) return false;
      }
      if (duty === "0" || duty === "1") {
        const itemDuty = String((item && item.dutyType) || "").trim();
        if (itemDuty !== duty) return false;
      }
      if (clearance === "0" || clearance === "1") {
        const itemClearance =
          String((item && item.clearanceMode) || "").trim() === "1" ? "1" : "0";
        if (itemClearance !== clearance) return false;
      }
      return true;
    },
    formatCountryLabel(code) {
      const c = String(code || "").trim().toUpperCase();
      if (!c) return "";
      const name = (this.countryLabelMap && this.countryLabelMap[c]) || c;
      return name === c ? c : `${name}（${c}）`;
    },
    formatChannelOptionLabel(item) {
      // 对客只展示渠道名，不拼括号内标签（目的国/海运/快递等已由上方筛选表达）
      return (item && item.name) || "";
    },
    loadChannelFilterPreference() {
      try {
        const raw = localStorage.getItem("portal.orderby2.channelFilter");
        if (!raw) return;
        const saved = JSON.parse(raw);
        const transport = saved && saved.transport;
        const delivery = saved && saved.delivery;
        const country = saved && saved.country;
        const duty = saved && saved.duty;
        const clearance = saved && saved.clearance;
        if (transport === "all" || transport === "01" || transport === "02") {
          this.channelFilterTransport = transport;
        } else if (transport === "") {
          this.channelFilterTransport = "all";
        }
        if (delivery === "all" || delivery === "1" || delivery === "2") {
          this.channelFilterDelivery = delivery;
        } else if (delivery === "") {
          this.channelFilterDelivery = "all";
        }
        if (country === "all" || country === "" || country == null) {
          this.channelFilterCountry = "all";
        } else if (typeof country === "string") {
          this.channelFilterCountry = String(country).trim().toUpperCase();
        }
        if (duty === "all" || duty === "0" || duty === "1") {
          this.channelFilterDuty = duty;
        } else if (duty === "") {
          this.channelFilterDuty = "all";
        }
        if (clearance === "all" || clearance === "0" || clearance === "1") {
          this.channelFilterClearance = clearance;
        } else if (clearance === "") {
          this.channelFilterClearance = "all";
        }
      } catch (e) {
        /* ignore broken preference */
      }
    },
    saveChannelFilterPreference() {
      try {
        localStorage.setItem(
          "portal.orderby2.channelFilter",
          JSON.stringify({
            transport: this.channelFilterTransport || "all",
            delivery: this.channelFilterDelivery || "all",
            country: this.channelFilterCountry || "all",
            duty: this.channelFilterDuty || "all",
            clearance: this.channelFilterClearance || "all"
          })
        );
      } catch (e) {
        /* ignore quota / private mode */
      }
    },
    clearChannelIfFilteredOut() {
      const selected = this.ruleForm.topChannel;
      if (selected === "" || selected == null) return;
      const stillVisible = this.filteredChannelData.some(group =>
        (group.options || []).some(item => item.id === selected || String(item.id) === String(selected))
      );
      if (!stillVisible) {
        this.ruleForm.topChannel = "";
        this.selectedClearanceMode = "";
      }
    },
    onChannelFilterChange() {
      if (!this.channelFilterCountry) this.channelFilterCountry = "all";
      this.saveChannelFilterPreference();
      this.clearChannelIfFilteredOut();
    },
    isDisabled(v){
      let a = "";
      this.timeData.forEach(i=>{
        if(i.name == v){
          a = i.value;
        }
      })
      return a=="true";
    },
    apiAction(type){
      if(type == "1"){
        return this.mApi + "/file/parseExcel/goods"
      }else if(type == "2"){
        return this.mApi + "/file/upload"
      }else if(type == "0"){
        return this.mApi + "/file/goodsTemplate"
      }else if(type == "3"){
        return this.mApi + "/file/parseExcel/shipment"
      }else if(type == "4"){
        return this.mApi + "/file/shipmentTemplate"
      }
    },
    validateProductRow(row) {
      const reg = /^(([0-9]+[\.]?[0-9]+)|[1-9])$/;
      const requiredFields = [
        { key: "picUrl", msg: "产品图片不能为空" },
        { key: "size", msg: "产品尺寸不能为空" },
        { key: "model", msg: "产品型号不能为空" },
        { key: "hscode", msg: "产品报关编码不能为空" },
        { key: "material", msg: "产品材质不能为空" },
        { key: "purpose", msg: "产品用途不能为空" },
        { key: "name", msg: "产品中文名不能为空" },
        { key: "ename", msg: "产品英文名不能为空" },
      ];
      for (const field of requiredFields) {
        if (row[field.key] === "" || row[field.key] == null) {
          this.$message.error(field.msg);
          return false;
        }
      }
      const numFields = [
        { key: "ctn", msg: "件数必须为正数" },
        { key: "qty", msg: "数量必须为正数" },
        { key: "unitValue", msg: "单价必须为正数" },
        { key: "totalValue", msg: "总价必须为正数" },
        { key: "nkg", msg: "净重必须为正数" },
        { key: "kg", msg: "实重必须为正数" },
        { key: "cbm", msg: "体积必须为正数" },
      ];
      for (const field of numFields) {
        if (!reg.test(String(row[field.key]))) {
          this.$message.error(field.msg);
          return false;
        }
      }
      return true;
    },
    validateShipmentRows() {
      for (const o in this.ruleForm.order_user) {
        const row = this.ruleForm.order_user[o];
        if (row.shipmentid === "" || row.referenceid === "") {
          this.$message.error("请填写完整预约号信息");
          return false;
        }
        if (
          isNaN(row.ctn) || isNaN(row.kg) || isNaN(row.cbm) ||
          row.ctn == 0 || row.kg == 0 || row.cbm == 0
        ) {
          this.$message.error("预约号信息出错");
          return false;
        }
      }
      return true;
    },
    findDispatchPlace(dispatchPlace) {
      for (const group of this.ruleForm.placeData) {
        const found = (group.options || []).find(item => item.cname === dispatchPlace);
        if (found) {
          return found;
        }
      }
      return null;
    },
    //下一步(正则)
    next(formName) {
      let that = this;
      that.$refs[formName].validate(valid => {
          if (valid) {//表单数据校验
            if (that.ruleForm.master_user.data.length === 0) {
              that.$message.error("请添加产品申报");
              return false;
            }
            const arr = that.ruleForm.master_userArr;
            for (const i in arr) {
              if (!that.validateProductRow(arr[i])) {
                return false;
              }
            }
            if (that.radio == 0) {
              if (!that.validateShipmentRows()) {
                return false;
              }
            } else {
              that.ruleForm.order_user = [];
            }
            that.analysis();
            that.active = 1;
          } else {
            that.$message.error("请填写完整信息");
            return false;
          }
        });
    },
    //上一步
    formNext() {
      this.active -= 1;
    },
    //订单完成
    toNext() {
      this.active = 0;
      this.$router.push("/orderby2");
    },
   
    openUploadDialog() {
      this.refreshUploadToken();
      this.dialogUploadVisible = true;
      this.uploadFileList = []; // 每次打开清空文件列表
    },
    // 刷新上传 token:el-upload 走原生 XHR 不经 axios 拦截器,data 里 myHeaders 只是挂载时的快照,
    // 重登/换 tab/清缓存后都会用旧 token 导致后端 40100「token校验失败」,故每次发请求前实时取。
    // 返回 true 是给 el-upload 的 :before-upload 用（作为钩子时不能返回 false，否则上传被拦）。
    refreshUploadToken() {
      this.myHeaders = { token: sessionStorage.getItem("token") || "" };
      return true;
    },
    // 上传前校验
    beforeOrderUpload(file) {
      this.refreshUploadToken();
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                    || file.type === 'application/vnd.ms-excel'
                    || /\.xlsx?$/i.test(file.name || '');
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isExcel) {
        this.$message.error('只能上传Excel文件!');
         return false; // 阻止上传
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过10MB!');
         return false; // 阻止上传
      }
      return true; // 允许上传
    },
     
    // 上传成功处理
    handleUploadSuccess(response) {
      // 防御:网关错误/异常时可能返回 HTML 或纯文本,而非 JSON
      let resp = response;
      if (typeof response === "string" && response.trim()) {
        try {
          resp = JSON.parse(response);
        } catch (e) {
          resp = { code: "error", message: "服务返回异常,请稍后重试" };
        }
      }
      if (!resp || typeof resp !== "object") {
        this.$message.error("导入失败:服务无响应");
        this.uploadFileList = [];
        return;
      }
      // 成功判定兼容:ok / success / 200 / 0 / true 等后端不同约定
      const codeRaw = resp.code !== undefined ? resp.code : resp.status;
      const code = String(codeRaw).toLowerCase();
      const isOk = code === "ok" || code === "success" || code === "200" || code === "0" || code === "true" || resp === true;

      if (isOk) {
        this.$message.success('订单导入成功');
        this.dialogUploadVisible = false;
      } else {
        this.$message.error(`导入失败: ${resp.message || resp.msg || "请检查文件后重试"}`);
      }
    },
    
    // 上传失败处理
    handleUploadError() {
      this.$message.error('上传失败，请重试');
    },
    
    // 文件超出数量限制
    handleExceed() {
      this.$message.warning('每次只能上传一个文件');
    },
    //提交订单
    async submitForm() {
      let that = this;
      if (that.submitting) return;
      const formOk = await new Promise((resolve) => {
        that.$refs.ruleForm.validate((valid) => resolve(!!valid));
      });
      if (!formOk) {
        that.$message.error("请填写完整信息");
        return;
      }
      if (!that.ruleForm.dispatchTime || Number.isNaN(Number(that.ruleForm.dispatchTime))) {
        that.$message.error("请选择有效送货时间");
        return;
      }
      let shipmentCode = "";
      if (that.ruleForm.wareCode != "") {
        shipmentCode = that.ruleForm.wareCode;
      } else if (that.ruleForm.whCode != "") {
        shipmentCode = that.ruleForm.whCode;
        that.ruleForm.order_user = [];
      }else if (that.ruleForm.whHoldCode != "") {
        shipmentCode = that.ruleForm.whHoldCode;
        that.ruleForm.order_user = [];
      }else if (that.ruleForm.endPort != "") {
        shipmentCode = that.ruleForm.endPort;
        that.ruleForm.order_user = [];
      }else if (that.ruleForm.wholesaleCode != "") {
        shipmentCode = that.ruleForm.wholesaleCode;
        that.ruleForm.order_user = [];
      }
      that.pickupList = [];
      let time = "";
      time = that.ruleForm.dispatchTime / 1000;
      let tf = true;
      if (that.takeVal) {
        that.pickObj.getsTime = that.pickObj.getsTimeC / 1000;
        that.pickObj.contact = this.factoryVal;
        that.pickObj.contactTel = this.telVal;
        that.pickObj.contactAdd = this.addressVal;
        that.pickObj.remark = this.ramakVal;
        that.pickupList.push(that.pickObj);
        if(that.pickObj.contact==""||that.pickObj.contactTel==""||that.pickObj.getsTime==""||that.pickObj.contactAdd==""){
          that.$message.error("请完善提货信息");
          tf = false;
        }
      };
      if (that.InsuranceVal) {
        if(that.insurancePeople==""||that.insuranceQuota==""||that.insuranceCurrency==""){
          that.$message.error("请完善保险信息");
          tf = false;
        }
      };
      if(!tf) return;
      that.submitting = true;
      try {
        const riskOk = await that.confirmGoodsRiskBeforeSubmit();
        if (!riskOk) return;
        const res = await httpApi.addOrder({
            channelId: that.ruleForm.topChannel,
            clientNo: that.ruleForm.topWaybill.trim(),
            containerType: that.ruleForm.topOcean[1],
            declareType: that.ruleForm.topDeclare,
            dispatchPlace: that.ruleForm.cenPlace,
            dispatchId: that.ruleForm.cenId,
            dispatchTime: time,
            freightMethod: that.ruleForm.topOceanNum,
            goodsList: that.ruleForm.master_userArr,
            importerId: that.ruleForm.cenImporValue,
            importerType: that.ruleForm.cenImporVal,
            insurance: that.insurance,
            insuranceMan: that.insurancePeople,
            insuranceFee: that.insuranceQuota,
            insuranceCurrency: that.insuranceCurrency,
            insuranceShelf: that.shelf,
            pickupList: that.pickupList,
            pickupType: that.pickupType,
            shipmentAddress: that.ruleForm.address,
            shipmentState: that.ruleForm.state,
            shipmentCode: shipmentCode,
            shipmentContact: that.ruleForm.addressee,
            shipmentZip: that.ruleForm.addzip,
            shipmentCountry: that.ruleForm.country,
            shipmentList: that.ruleForm.order_user,
            shipmentTel: that.ruleForm.telPhone,
            shipmentType: that.radio,
            shipperId: that.ruleForm.cenDeliver,
            userRemark: that.ruleForm.inputValue,
            quoteFeeList: that.quoteFeeList
          });
        if (res.data.code == "ok") {
          that.$message.success("下单成功");
          that.orderVal = res.data.data;
          that.active = 2;
          that.ruleForm.dispatchTime = "";
          that.ruleForm.topWaybill = "";
          if (this.responseDataUp){
            that.setFile(this.responseDataUp);
          }
        } else {
          that.$message.error(res.data.message);
        }
      } catch (e) {
        that.$message.error((e && e.message) || "下单失败，请稍后重试");
      } finally {
        that.submitting = false;
      }
    },
    scheduleGoodsRiskCheck() {
      if (this._goodsRiskTimer) clearTimeout(this._goodsRiskTimer);
      this._goodsRiskTimer = setTimeout(() => this.refreshGoodsRisk(), 400);
    },
    async refreshGoodsRisk() {
      try {
        const rows = this.ruleForm.master_userArr || [];
        const goodsList = rows.map((g) => ({ name: g.name, ename: g.ename }));
        if (!goodsList.length) {
          this.goodsRiskHit = false;
          return;
        }
        const res = await httpApi.goodsRiskCheck({
          country: this.ruleForm.country,
          goodsList
        });
        if (res.data.code !== 'ok') return;
        this.goodsRiskHit = applyGoodsRiskToRows(rows, res.data.data || {}, this.$set.bind(this));
      } catch (e) { /* ignore */ }
    },
    async confirmGoodsRiskBeforeSubmit() {
      try {
        const rows = this.ruleForm.master_userArr || [];
        const goodsList = rows.map((g) => ({ name: g.name, ename: g.ename }));
        if (!goodsList.length) return true;
        const res = await httpApi.goodsRiskCheck({
          country: this.ruleForm.country,
          goodsList
        });
        if (res.data.code !== 'ok') return true;
        const data = res.data.data || {};
        this.goodsRiskHit = applyGoodsRiskToRows(rows, data, this.$set.bind(this));
        if (!data.hit) return true;
        const lines = buildGoodsRiskConfirmLines(data);
        await this.$confirm(
          (lines.length ? lines.join('\n') : data.message) + '\n\n仅提醒，可继续下单。请确认品名如实申报。',
          '品名合规提示',
          { type: 'warning', confirmButtonText: '已知晓，继续下单', cancelButtonText: '返回修改' }
        );
        return true;
      } catch (e) {
        if (e === 'cancel') return false;
        return true;
      }
    },
    async downloadTemp(){
      const response = await httpApi.downloadTemp();
      // 创建URL对象
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // 创建a标签
      const a = document.createElement('a');
      a.href = url;
      // 设置文件名（支持中文）
      a.download = `订单导入模版.xlsx`;
      // 触发点击下载
      document.body.appendChild(a);
      a.click();
      // 清理资源
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    //送货时间
    dispatchTime() {
      var num = "";
      num = this.ruleForm.dispatchTime;
      if (!num && num !== 0) {
        return;
      }
      this.ruleForm.dispatchTime = new Date(num).getTime();
      this.day = new Date(num).getTime();
      // 仅需到仓日期：不再弹出“时段选择”二次弹窗
      // var startAt = (new Date(this.ruleForm.dispatchTime) * 1000) / 1000;
      // if (startAt < Date.now()) {
      //   this.ruleForm.dispatchTime = new Date().getTime();
      // }
    },
    setTime(times){
      let h = 3600000*times;
      if (this.ruleForm.dispatchTime!=null&&this.ruleForm.dispatchTime!=''){
        this.ruleForm.dispatchTime = this.day + h;
      }
    },
    getTimeData(){
      let time = this.ruleForm.dispatchTime / 1000;
      httpApi
        .getTimeData({
          params:{
            time: time,
            dispatchId: this.ruleForm.cenId
          }
        })
        .then(res=>{
          this.timeData = res.data.data
        })
    },
    //报关方式：仅 0110退税(1) 走退税相关标记；其余含买单/特殊监管均为非退税核对
    topDe(val) {
      const declareVal = val !== undefined ? val : this.ruleForm.topDeclare;
      this.ruleForm.topDeclVal = declareVal === "1" ? "1" : "0";
    },
    //承运方式拼柜整柜
    oceanShip() {
      for (let i in this.ruleForm.topOcean) {
        if (this.ruleForm.topOcean[i] == "拼柜") {
          this.ruleForm.topOceanNum = "0";
        } else if (this.ruleForm.topOcean[i] == "整柜") {
          this.ruleForm.topOceanType = this.ruleForm.topOcean[1];
          this.ruleForm.topOceanNum = "1";
        }
      }
    },
    //备注标签
    getTag(val) {
      this.ruleForm.inputValue += val + " ";
    },
    wareList() {
      httpApi.listParams({ params: { type: "sys_fbacode",enable:"1"} }).then(res => {
        if (res.data.code == "ok") {
          this.ruleForm.wareData = res.data.data;
          // this.addressInfo = this.ruleForm.wareData[0].address;
          for (let i in this.ruleForm.wareData) {
            this.ruleForm.wareData[i].lable =
              this.ruleForm.wareData[i].code +
              " " +
              this.ruleForm.wareData[i].zip;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    whList() {
      httpApi.listParams({ params: { type: "sys_wh",enable:"1" } }).then(res => {
        if (res.data.code == "ok") {
          this.ruleForm.whData = res.data.data;
          // that.addressInfo = that.ruleForm.whData[0].address;
          for (let i in this.ruleForm.whData) {
            this.ruleForm.whData[i].lable =
              this.ruleForm.whData[i].code + " " + this.ruleForm.whData[i].zip;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    whHoldList() {
      httpApi.listParams({ params: { type: "sys_wh_hold",enable:"1" } }).then(res => {
        if (res.data.code == "ok") {
          let whHoldData = [];
          // that.addressInfo = that.ruleForm.whHoldData[0].address;
          let resData = res.data.data;
          for (let i in resData) {
            resData[i].lable =
            resData[i].code + " " + resData[i].zip + " " + resData[i].serves;
            if(resData[i].serves.includes('自提')||resData[i].serves.includes('留仓')){
              whHoldData.push(resData[i]);
            }
          }
          this.ruleForm.whHoldData = whHoldData;
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.loadDaifaWarehouses();
    },
    loadDaifaWarehouses() {
      httpApi.listDaifaWarehouse().then(res => {
        if (res.data && res.data.code === "ok") {
          const list = res.data.data || [];
          this.ruleForm.wholesaleData = list.map(w => ({
            code: w.whCode,
            lable: (w.serviceName || "") + " " + w.whCode + " 一件代发",
            serves: "一件代发",
            zip: w.serviceCode || ""
          }));
        } else {
          this.ruleForm.wholesaleData = [];
        }
      }).catch(() => {
        this.ruleForm.wholesaleData = [];
      });
    },
    getEndPortList() {

      httpApi
        .listParams( {
          params: {
            type: "sys_port",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            this.ruleForm.endPortList = res.data.data;
          }
        });

    },
    //订单类型查询
    listOrderType() {
      let that = this;
      httpApi
        .listParams({ params: { type: "sys_order_type",enable:"1" } })
        .then(res => {
          if (res.data.code == "ok") {
            res.data.data.forEach(e=>{
              if(e.orderType=="0"){
                that.orderType0 = e.isEnable;
              }else if(e.orderType=="1"){
                that.orderType1 = e.isEnable;
              }else if(e.orderType=="2"){
                that.orderType2 = e.isEnable;
              }else if(e.orderType=="3"){
                that.orderType3 = e.isEnable;
              }else if(e.orderType=="4"){
                that.orderType4 = e.isEnable;
              }else if(e.orderType=="5"){
                that.orderType5 = e.isEnable;
              }
              if(e.isEnable&&Number(e.orderType)<that.radio){
                that.radio = Number(e.orderType);
                this.radioVal();
              }
            })
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    //渠道查询
    listChannel() {
      httpApi.listChannelForCustomer({ params: {} }).then(res => {
        if (res.data.code == "ok") {
          this.ruleForm.channelData = [];
          (res.data.data || []).forEach(element => {
            this.ruleForm.channelData.push({ label: element.label, options: element.list });
          });
          this.clearChannelIfFilteredOut();
        }
      });
    },
    //整柜查询
    listContainer() {
      httpApi
        .listParams({ params: { type: "sys_container_type",enable:"1" } })
        .then(res => {
          if (res.data.code == "ok") {
            this.ruleForm.oceanData[1].children = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //送货地查询
    listPlaceOder() {
      let that = this;
      httpApi
        .getPort({ params: { type: "sys_dispatch_place" } })
        .then(res => {
          if (res.data.code == "ok") {
          res.data.data.forEach(element => {
            this.ruleForm.placeData.push({ label: element.label, options: element.list });
          });
          this.$nextTick(() => this.autoSelectSingleDispatchPlace());
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    //地址
    radioVal() {
      if (this.radio == 0) {
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = "";
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.addressInfo="";
        this.addressInfo = "";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.wareCode[0].required = true;
        this.rules.whCode[0].required = false;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      } else if (this.radio == 1) {
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.wareCode[0].required = false;
        this.rules.whCode[0].required = false;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = false;
        this.rules.addressee[0].required = true;
        this.rules.state[0].required = true;
        this.rules.addzip[0].required = true;
        this.rules.telPhone[0].required = true;
        this.rules.address[0].required = true;
        this.rules.country[0].required = true;
      } else if (this.radio == 2) {
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.whCode[0].required = true;
        this.rules.wareCode[0].required = false;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      } else if (this.radio == 3){
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.whHoldCode[0].required = true;
        this.rules.wholesaleCode[0].required = false;
        this.rules.wareCode[0].required = false;
        this.rules.whCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      } else if (this.radio == 4){
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = true;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = false;
        this.rules.wareCode[0].required = false;
        this.rules.whCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      } else if (this.radio == 5){
        this.ruleForm.wareCode = "";
        this.ruleForm.addressee = ""; 
        this.ruleForm.state = "";
        this.ruleForm.addzip = ""; 
        this.ruleForm.telPhone = ""; 
        this.ruleForm.address = "";
        this.ruleForm.country="";
        this.ruleForm.whCode = "";
        this.ruleForm.whHoldCode="";
        this.ruleForm.wholesaleCode="";
        this.ruleForm.endPort = "";
        this.rules.endPort[0].required = false;
        this.rules.whHoldCode[0].required = false;
        this.rules.wholesaleCode[0].required = true;
        this.rules.wareCode[0].required = false;
        this.rules.whCode[0].required = false;
        this.rules.addressee[0].required = false;
        this.rules.state[0].required = false;
        this.rules.addzip[0].required = false;
        this.rules.telPhone[0].required = false;
        this.rules.address[0].required = false;
        this.rules.country[0].required = false;
      }
    },
    //国家
    getCountry(e) {
      this.ruleForm.country = e;
    },
    //查询发货人
    deliverUser() {
      httpApi
        .queryUser({
          params: {
            type: 1
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            this.ruleForm.deliverData = res.data.data.rows;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //查询进口商
    importedUser() {
      httpApi
        .queryUser({
          params: {
            type: 0
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            this.ruleForm.importedData = res.data.data.rows;
            this.ruleForm.cenImported = 1;
            this.ruleForm.cenImporVal = "1";
            this.ruleForm.cenImportext = "公司进口商";
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //进口商名字
    cen(val) {
      let obj = {};
      if (this.ruleForm.cenImported == "1") {
        this.ruleForm.cenImporVal = "1";
        this.ruleForm.cenImporValue = "";
        this.ruleForm.cenImportext = "公司进口商";
      } else {
        this.ruleForm.importedData.map(item => {
          if (item.id === val) {
            obj = item;
          }
        });
        this.ruleForm.cenImportext = formatImporterOptionLabel(obj);
        this.ruleForm.cenImporValue = obj.id;
        this.ruleForm.cenImporVal = "0";
      }
    },
    formatImporterOptionLabel,
    //发货人名字
    cenDe(e) {
      let obj = {};
      this.ruleForm.deliverData.map(item => {
        //  this.importedData 是你 select option遍历的集合 e 是选中的id
        if (item.id === e) {
          obj = item;
        }
      });
      this.ruleForm.cenDelivertext = obj.name + obj.address;
    },
    //tag标签
    listTag() {
      httpApi
        .listParams({ params: { type: "sys_order_remark_tag",enable:"1" } })
        .then(res => {
          if (res.data.code == "ok") {
            this.dynamicTags = res.data.data.map(item => {
              return item.name;
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //送货人名字
    cenPl(e) {
      let obj = {};
      this.ruleForm.placeData.map(item => {
        item.options.map(item2=>{
          if (item2.cname === e) {
            obj = item2;
            this.ruleForm.cenId = item2.id
          }
        })
      });
      // 不对客展示真地址；仅提示城市/收货点名
      this.textVal = "";
      this.dispatchHintText = obj.cname ? ("送货地：" + obj.cname) : "";
    },
    onChannelChange(channelId) {
      this.selectedClearanceMode = "";
      if (channelId) {
        for (const group of this.ruleForm.channelData || []) {
          const hit = (group.options || []).find(
            item => item.id === channelId || String(item.id) === String(channelId)
          );
          if (hit) {
            this.selectedClearanceMode =
              String(hit.clearanceMode || "").trim() === "1" ? "1" : "0";
            break;
          }
        }
      }
      if (this.selectedClearanceMode !== "1") {
        this.resetImporterToCompany();
      }
      this.applyChannelDispatchConfig(channelId);
      this.tryApplyLastDefaults(channelId);
    },
    clearLastDefaultsBanner() {
      this.lastDefaultsBannerVisible = false;
      this.lastDefaultsOrderNo = "";
      this.lastDefaultsSnapshot = null;
    },
    snapshotLastDefaultsFields() {
      return {
        topDeclare: this.ruleForm.topDeclare,
        topDeclVal: this.ruleForm.topDeclVal,
        topOcean: Array.isArray(this.ruleForm.topOcean)
          ? this.ruleForm.topOcean.slice()
          : this.ruleForm.topOcean,
        topOceanNum: this.ruleForm.topOceanNum,
        topOceanType: this.ruleForm.topOceanType,
        cenImported: this.ruleForm.cenImported,
        cenImporVal: this.ruleForm.cenImporVal,
        cenImporValue: this.ruleForm.cenImporValue,
        cenImportext: this.ruleForm.cenImportext,
        radio: this.radio,
        wareCode: this.ruleForm.wareCode,
        whCode: this.ruleForm.whCode,
        whHoldCode: this.ruleForm.whHoldCode,
        endPort: this.ruleForm.endPort,
        wholesaleCode: this.ruleForm.wholesaleCode
      };
    },
    restoreLastDefaultsSnapshot(snap) {
      if (!snap) return;
      this.ruleForm.topDeclare = snap.topDeclare;
      this.ruleForm.topDeclVal = snap.topDeclVal;
      this.topDe(snap.topDeclare);
      this.ruleForm.topOcean = Array.isArray(snap.topOcean)
        ? snap.topOcean.slice()
        : snap.topOcean;
      this.ruleForm.topOceanNum = snap.topOceanNum;
      this.ruleForm.topOceanType = snap.topOceanType;
      this.ruleForm.cenImported = snap.cenImported;
      this.ruleForm.cenImporVal = snap.cenImporVal;
      this.ruleForm.cenImporValue = snap.cenImporValue;
      this.ruleForm.cenImportext = snap.cenImportext;
      this.radio = snap.radio;
      this.radioVal();
      this.ruleForm.wareCode = snap.wareCode;
      this.ruleForm.whCode = snap.whCode;
      this.ruleForm.whHoldCode = snap.whHoldCode;
      this.ruleForm.endPort = snap.endPort;
      this.ruleForm.wholesaleCode = snap.wholesaleCode;
    },
    undoLastDefaults() {
      this.restoreLastDefaultsSnapshot(this.lastDefaultsSnapshot);
      this.clearLastDefaultsBanner();
    },
    applyLastDefaultsShipment(data) {
      const st = data.shipmentType == null ? "" : String(data.shipmentType);
      const code = data.shipmentCode;
      if (!code || st === "1") {
        return;
      }
      if (st === "0") {
        this.radio = 0;
        this.radioVal();
        this.ruleForm.wareCode = code;
      } else if (st === "2") {
        this.radio = 2;
        this.radioVal();
        this.ruleForm.whCode = code;
      } else if (st === "3") {
        this.radio = 3;
        this.radioVal();
        this.ruleForm.whHoldCode = code;
      } else if (st === "4") {
        this.radio = 4;
        this.radioVal();
        this.ruleForm.endPort = code;
      } else if (st === "5") {
        this.radio = 5;
        this.radioVal();
        this.ruleForm.wholesaleCode = code;
      }
    },
    applyLastDefaultsImporter(data) {
      if (!this.importerSelectEnabled) {
        this.resetImporterToCompany();
        return;
      }
      if (data.importerType === "1" || !data.importerName) {
        this.resetImporterToCompany();
        return;
      }
      const importer = (this.ruleForm.importedData || []).find(
        item => item.name === data.importerName
      );
      if (importer) {
        this.ruleForm.cenImported = importer.id;
        this.ruleForm.cenImporVal = "0";
        this.ruleForm.cenImporValue = importer.id;
        this.ruleForm.cenImportext = formatImporterOptionLabel(importer);
      } else {
        this.resetImporterToCompany();
      }
    },
    tryApplyLastDefaults(channelId) {
      this.clearLastDefaultsBanner();
      if (!channelId || this.$route.query.orderNo) {
        return;
      }
      const seq = ++this._lastDefaultsReqSeq;
      httpApi
        .lastOrderDefaults({ params: { channelId } })
        .then(res => {
          if (seq !== this._lastDefaultsReqSeq) return;
          if (!res.data || res.data.code !== "ok" || !res.data.data) return;
          const data = res.data.data;
          if (!data.hit || !data.orderNo) return;
          const snapshot = this.snapshotLastDefaultsFields();
          if (data.declareType != null && data.declareType !== "") {
            this.ruleForm.topDeclare = String(data.declareType);
            this.topDe(this.ruleForm.topDeclare);
          }
          if (String(data.freightMethod) === "0") {
            this.ruleForm.topOcean = ["拼柜"];
            this.ruleForm.topOceanNum = "0";
            this.ruleForm.topOceanType = "";
          } else if (String(data.freightMethod) === "1") {
            this.ruleForm.topOcean = ["整柜", data.containerType || ""];
            this.ruleForm.topOceanNum = "1";
            this.ruleForm.topOceanType = data.containerType || "";
          }
          this.applyLastDefaultsImporter(data);
          this.applyLastDefaultsShipment(data);
          this.lastDefaultsSnapshot = snapshot;
          this.lastDefaultsOrderNo = data.orderNo;
          this.lastDefaultsBannerVisible = true;
        })
        .catch(() => {});
    },
    resetImporterToCompany() {
      this.ruleForm.cenImported = 1;
      this.ruleForm.cenImporVal = "1";
      this.ruleForm.cenImporValue = "";
      this.ruleForm.cenImportext = "公司进口商";
    },
    applyChannelDispatchConfig(channelId) {
      this.dispatchSelectDisabled = false;
      this.channelDispatchOptionIds = null;
      this.dispatchHintText = "";
      if (!channelId) {
        this.$nextTick(() => this.autoSelectSingleDispatchPlace());
        return;
      }
      httpApi.channelDispatchConfig({ params: { channelId } }).then(res => {
        if (!res.data || res.data.code !== "ok" || !res.data.data) {
          return;
        }
        const cfg = res.data.data;
        const options = cfg.options || [];
        if (!options.length) {
          return;
        }
        this.channelDispatchOptionIds = options.map(o => o.id);
        if (options.length > 1) {
          this.dispatchSelectDisabled = false;
          this.dispatchHintText = "请选择送货仓库";
          const ok = options.some(o => String(o.id) === String(this.ruleForm.cenId));
          if (!ok) {
            this.ruleForm.cenPlace = "";
            this.ruleForm.cenId = "";
          }
          return;
        }
        // 仅一个可选仓：自动选中并锁定，无需再选
        this.autoSelectSingleDispatchPlace();
      }).catch(() => {});
    },
    /** 当前可选送货仓恰好 1 个时自动带出并锁定 */
    autoSelectSingleDispatchPlace() {
      const options = [];
      (this.displayPlaceData || []).forEach(g => {
        (g.options || []).forEach(o => options.push(o));
      });
      if (options.length !== 1) {
        return;
      }
      const only = options[0];
      const name = only.cname;
      if (!name) {
        return;
      }
      this.ruleForm.cenId = only.id;
      this.ruleForm.cenPlace = name;
      this.dispatchSelectDisabled = true;
      this.dispatchHintText = "已自动选定收货仓：" + name;
      this.textVal = "";
      this.cenPl(name);
    },
    //改变code地址
    wareDataAddress(e) {
      let obj = {};
      this.ruleForm.wareData.map(item => {
        //  this.importedData 是你 select option遍历的集合 e 是选中的id
        if (item.code === e) {
          obj = item;
        }
      });
      this.addressInfo = obj.address;
    },
    //上传excel表格
    async handProduct(response, file, fileList) {
      if (response.code !== "ok" && response.message !== "成功") {
        this.$message.error(response.message || "导入失败");
        return;
      }
      if (!response.data || !response.data.list) {
        this.$message.error("导入数据为空");
        return;
      }
      this.responseDataUp = response.data.upload;
      this.ruleForm.master_user.data = response.data.list;
      var goods = this.ruleForm.master_user.data;
      var goodsList = [];
      var shipmentData = [];
      for (var i = 0; i < goods.length; i++) {
        var g = {};
        var obj = goods[i];

        //有品名添加
        if(obj[1]!=""&&obj[1]!=null&&obj[1]!=undefined){
          if(obj[7]=="否"||obj[7]=="只带电"||obj[7]=="只带磁"||obj[7]=="带电带磁"){
            g.electrificationState = obj[7];
          }else{
            await this.$message.error("带电带磁格式错误");
            g.electrificationState = "";
          };
          if(obj[9]=="无品牌"||obj[9]=="境内自主品牌"||obj[9]=="境内收购品牌"||obj[9]=="境外品牌(贴牌生产)"||obj[9]=="境外品牌(其他)"){
            g.brandType = obj[9];
          }else{
            await this.$message.error("品牌类型格式错误");
            g.brandType = "";
          };
          g.name = obj[0];
          g.ename = obj[1];
          g.material = obj[2];
          g.purpose = obj[3];
          g.hscode = obj[4];
          g.gwcode = obj[5];
          g.taxRate = obj[6];
          g.brand = obj[8];
          g.model = obj[10];
          g.ctn = obj[11];
          g.qty = obj[12];
          g.unitValue = obj[13];
          g.totalValue = obj[14];
          g.size = obj[15] + "*" + obj[16] + "*" + obj[17];
          g.nkg = obj[18];
          g.kg = obj[19];
          g.cbm = obj[20];
          g.picUrl = obj.picUrl || "";
          g.markNo = obj[25];
          g.fnsku = obj[26];
          g.selleLink = obj[27];
          goodsList.push(g);
        }
        //有预约号添加
        if(obj[22]!=""&&obj[22]!=null&&obj[22]!=undefined){
          var s = {};
          s.shipmentid = obj[22];
          s.referenceid = obj[23];
          s.ctn = 0.00;
          s.kg = 0.00;
          s.cbm = 0.00;
          shipmentData.push(JSON.parse(JSON.stringify(s)));
        }
      }
      this.ruleForm.master_user.data = JSON.parse(JSON.stringify(goodsList));
      this.ruleForm.master_userArr = JSON.parse(JSON.stringify(goodsList));
      this.ruleForm.order_user = shipmentData;
      this.analysis();
    },
    setFile(response) {
      let that = this;
      let arr = response;
      httpApi
        .addFile({
          ext: arr.ext,
          name: arr.filename,
          orderNo: that.orderVal,
          size: arr.size,
          type: "5",
          url: arr.url
        });
    },
    analysis(){
      for (let i in this.ruleForm.master_userArr) {
        let numBT = this.ruleForm.master_userArr[i].brandType;//品牌类型解析
        switch(numBT){
          case "无品牌":
            this.ruleForm.master_userArr[i].brandType = "0"
            break;
          case "境内自主品牌":
            this.ruleForm.master_userArr[i].brandType = "1"
            break;
          case "境内收购品牌":
            this.ruleForm.master_userArr[i].brandType = "2"
            break;
          case "境外品牌(贴牌生产)":
          case "境外品牌（贴牌生产）":
            this.ruleForm.master_userArr[i].brandType = "3"
            break;
          case "境外品牌(其他)":
          case "境外品牌（其他）":
            this.ruleForm.master_userArr[i].brandType = "4"
            break;
        }
        let numES = this.ruleForm.master_userArr[i].electrificationState;//带电带磁解析
        switch(numES){
          case "否":
            this.ruleForm.master_userArr[i].electrificationState = "0"
            break;
          case "只带电":
            this.ruleForm.master_userArr[i].electrificationState = "1"
            break;
          case "只带磁":
            this.ruleForm.master_userArr[i].electrificationState = "2"
            break;
          case "带电带磁":
            this.ruleForm.master_userArr[i].electrificationState = "3"
            break;
        }
      }
    },
    //删除表格清空数据
    handRemove(){
      this.ruleForm.master_user.data = [];
      this.ruleForm.master_userArr = [];
    },
    //添加空数据
    addRow(){
      this.ruleForm.master_user.data.push(
        JSON.parse(JSON.stringify(this.goodsNullList))
      );
      this.ruleForm.master_userArr.push(
        JSON.parse(JSON.stringify(this.goodsNullList))
      );
    },
    //删除数据
    deleteRow(index, rows, rowsArr) {
      rows.splice(index, 1);
      rowsArr.splice(index, 1);
    },
    //点击行选中
    handleRowClick(row, column, event){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    // 上传图片成功
    handleSuccess(response, file, fileList, index) {
      // $set 保证 Excel 导入行(键可能缺失/非响应式)回填图片后视图即时刷新
      this.$set(this.ruleForm.master_userArr[index], "picUrl", response.data.url);
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1].raw]  // 这一步，是 展示最后一次选择的文件
      }
    },
    beforeUpload(file){
      // 图片上传同样走 el-upload 原生 XHR，发请求前必须换成本次登录的最新 token
      this.refreshUploadToken();
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('只能上传jpg或png格式的图片');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    //预约号添加
    insert: function() {
      this.ruleForm.order_user.push(
        JSON.parse(JSON.stringify(this.ruleForm.order_userArr))
      );
      const idx = this.ruleForm.order_user.length - 1;
      this.ruleForm.order_user[idx].kg = "";
      this.ruleForm.order_user[idx].ctn = "";
      this.ruleForm.order_user[idx].cbm = "";
    },
    //预约号删除
    remove: function(index) {
      this.ruleForm.order_user.splice(index, 1);
    },
    //上门提货
    take() {
      if (this.takeVal) {
        this.pickupType = "1";
      } else {
        this.pickupType = "0";
      }
    },
    //保险
    Insurance() {
      if (this.InsuranceVal) {
        this.insurance = "1";
      } else {
        this.insurance = "0";
      }
    },
    //取货时间
    pickTime() {
      // this.pickObj.geteTime = new Date(this.creteTime[0]).getTime();
      this.pickObj.getsTimeC = new Date(this.creteTime).getTime();
    },
    // //下载唛头
    getMaitou() {
      this.dialogFormVisible3 = true;
      this.init3();
    },
    getMaitou2(type) {
      this.dialogFormVisible3 = false;
      let typeFlag = type ? "a4" : "";
      window.open(
        this.mApi +
          "report/mai_tou3?orderNo=" + this.orderVal + "&type=" + typeFlag + "&marksModel=" + this.marks.marksModel +"&suffix="+this.marks.suffix+"&serialNum="+this.marks.serialNum+"&isHasSuffix="+this.marks.isHasSuffix
      );
    },
    renderHeader(h, { column }) {
      return [
        h("span", {style: "color: red"}, "*"),
        h("span", " "+column.label)
      ]
    },
    init3() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_marks",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options3 = res.data.data;
          }
        });
    },
    //下载入仓
    getRucangdan() {
      window.open(this.mApi + "/report/ru_cang_dan?orderNo=" + this.orderVal);
    },
    CopyOrderlist() {
      let that = this;
      httpApi
        .findOrder({ params: { orderNo: that.$route.query.orderNo } })
        .then(res => {
          if (res.data.code == "ok") {
            let arr = res.data.data.findOrderResponse;
            let chanpin = res.data.data.findOrderGoodsResponseList;
            let shipments = res.data.data.findOrderShipmentResponseList || [];
            that.ruleForm.topChannel = arr.channelId;
            that.onChannelChange(arr.channelId);
            that.ruleForm.topDeclare = arr.declareType;
            that.topDe(arr.declareType);
            that.ruleForm.topWaybill = arr.clientNo || "";
            that.ruleForm.inputValue = arr.userRemark || "";
            if (that.importerSelectEnabled && arr.importerType !== "1") {
              const importer = (that.ruleForm.importedData || []).find(
                item => item.name === arr.importerName
              );
              if (importer) {
                that.ruleForm.cenImported = importer.id;
                that.ruleForm.cenImporVal = "0";
                that.ruleForm.cenImporValue = importer.id;
                that.ruleForm.cenImportext = formatImporterOptionLabel(importer);
              } else {
                that.resetImporterToCompany();
              }
            } else {
              that.resetImporterToCompany();
            }
            if (arr.dispatchPlace) {
              that.ruleForm.cenPlace = arr.dispatchPlace;
              that.ruleForm.cenId = arr.dispatchId || "";
              const place = that.findDispatchPlace(arr.dispatchPlace);
              if (place) {
                that.textVal = place.address;
                if (!that.ruleForm.cenId) {
                  that.ruleForm.cenId = place.id;
                }
              }
            }
            if (arr.dispatchTime) {
              that.ruleForm.dispatchTime = arr.dispatchTime * 1000;
            }
            if (arr.shipmentType == "0") {
              that.radio = 0;
              that.radioVal();
              that.ruleForm.wareCode = arr.shipmentCode; 
            } else if (arr.shipmentType == "1") {
              that.radio = 1;
              that.radioVal();
              that.ruleForm.country = arr.shipmentCountry;
              that.ruleForm.addressee = arr.shipmentContact;
              that.ruleForm.state = arr.shipmentState;
              that.ruleForm.addzip = arr.shipmentZip;
              that.ruleForm.telPhone = arr.shipmentTel;
              that.ruleForm.address = arr.shipmentAddress;
            } else if(arr.shipmentType == "2") {
              that.radio = 2;
              that.radioVal();
              that.ruleForm.whCode = arr.shipmentCode;
            }else if(arr.shipmentType == "3") {
               that.radio = 3;
               that.radioVal();
               that.ruleForm.whHoldCode = arr.shipmentCode;
            }else if(arr.shipmentType == "4") {
               that.radio = 4;
               that.radioVal();
               that.ruleForm.endPort = arr.shipmentCode;
            }else{
               that.radio = 5;
               that.radioVal();
               that.ruleForm.wholesaleCode = arr.shipmentCode;
            }
            if (arr.freightMethod == "0") {
              that.ruleForm.topOcean = ["拼柜"];
              that.ruleForm.topOceanNum = "0";
            } else {
              that.ruleForm.topOcean = ["整柜", arr.containerType];
              that.ruleForm.topOceanNum = "1";
            }
            let b = that.ruleForm.deliverData.find(i => {
              return i.name == arr.shipperName;
            });
            if (b == undefined || b == null || b == "") {
              that.ruleForm.cenDeliver = "";
            } else {
              that.ruleForm.cenDeliver = b.id; 
            }
            //产品申报
            that.ruleForm.master_user.data = chanpin;
            let goods = that.ruleForm.master_user.data;
            let goodsList = [];
            for (var i = 0; i < goods.length; i++) {
              var g = {};
              var obj = goods[i];
              g.name = obj.name;
              g.ename = obj.ename;
              g.material = obj.material;
              g.purpose = obj.purpose;
              g.hscode = obj.hscode;
              g.gwcode = obj.gwcode;
              g.taxRate = obj.taxRate;
              g.electrificationState = obj.electrificationState;
              g.brand = obj.brand;
              g.brandType = obj.brandType;
              g.model = obj.model;
              g.ctn = obj.ctn;
              g.qty = obj.qty;
              g.unitValue = obj.unitValue;
              g.totalValue = obj.totalValue;
              g.kg = obj.kg;
              g.size = obj.size;
              g.nkg = obj.nkg;
              g.kg = obj.kg;
              g.cbm = obj.cbm;
              g.picUrl = obj.picUrl || "";
              g.markNo = obj.markNo;
              g.fnsku = obj.fnsku;
              g.selleLink = obj.selleLink;
              goodsList.push(g);
            }
            that.ruleForm.master_user.data = JSON.parse(
              JSON.stringify(goodsList)
            );
            that.ruleForm.master_userArr = JSON.parse(
              JSON.stringify(goodsList)
            );
            for (let i in that.ruleForm.master_userArr) {
              that.ruleForm.master_userArr[i]["qty"] = parseInt(
                that.ruleForm.master_userArr[i]["qty"]
              );
              that.ruleForm.master_userArr[i]["ctn"] = parseInt(
                that.ruleForm.master_userArr[i]["ctn"]
              );
            }
            if (arr.shipmentType == "0" && shipments.length > 0) {
              that.ruleForm.order_user = shipments.map(s => ({
                shipmentid: s.shipmentid || "",
                referenceid: s.referenceid || "",
                ctn: s.ctn || 0,
                kg: s.kg || 0,
                cbm: s.cbm || 0
              }));
            }
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    async handShipmentId(response,file,fileList){
      if (response.code !== "ok" && response.message !== "成功") {
        this.$message.error(response.message || "导入失败");
        return;
      }
      if (!response.data) {
        this.$message.error("导入数据为空");
        return;
      }
      let shipmentList = response.data;
      let order_userList = [];
      for (let i in shipmentList) {
        let order_userItem = JSON.parse(JSON.stringify(this.ruleForm.order_userArr));
        order_userItem.shipmentid = shipmentList[i][0];
        order_userItem.referenceid = shipmentList[i][1];
        order_userItem.ctn = shipmentList[i][2];
        order_userItem.kg = shipmentList[i][3];
        order_userItem.cbm = shipmentList[i][4];
        order_userList.push(JSON.parse(JSON.stringify(order_userItem)));
      }
      this.ruleForm.order_user = order_userList;
    },

    queryProduct() {
      let that = this;
      return httpApi
        .queryProduct({
          params: {
            page: that.currentPage,
            rows: that.pagesize,
            name: that.inputVal
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.productData = res.data.data.rows;
            that.total = res.data.data.total;
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    //添加已有产品
    addList() {
      this.dialogVisible = true;
      this.queryProduct();
    },
    selectData(val) {
      this.selectDatas = val
    },
    add(){
      let arr = [];
      for (const i in this.selectDatas) {
        let obj = {};
        obj["name"] = this.selectDatas[i].name;
        obj["ename"] = this.selectDatas[i].ename;
        obj["material"] = this.selectDatas[i].material;
        obj["purpose"] = this.selectDatas[i].purpose;
        obj["hscode"] = this.selectDatas[i].hscode;
        obj["gwcode"] = this.selectDatas[i].gwcode;
        obj["taxRate"] = this.selectDatas[i].taxRate;
        obj["electrificationState"] = this.selectDatas[i].electrificationState;
        obj["brand"] = this.selectDatas[i].brand;
        obj["brandType"] = this.selectDatas[i].brandType;
        obj["model"] = this.selectDatas[i].model;
        obj["ctn"] = 1;
        obj["qty"] = 1;
        obj["unitValue"] = "";
        obj["totalValue"] = "";
        obj["nkg"] = "";
        obj["kg"] = "";
        obj["size"] =this.selectDatas[i].size;
        obj["sku"] = this.selectDatas[i].sku || "";
        obj["fnsku"] = this.selectDatas[i].fnsku || "";
        obj["asin"] = this.selectDatas[i].asin || "";
        obj["boxGroup"] = "";
        obj["cbm"] = "";
        obj["picUrl"] = this.selectDatas[i].picUrl || "";
        arr.push(obj)
      }
      this.ruleForm.master_user.data = [...this.ruleForm.master_user.data, ...arr];
      this.ruleForm.master_userArr = [...this.ruleForm.master_userArr, ...arr];
      this.analysis();
      this.dialogVisible = false;
    },
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.currentPage = 1;
      this.queryProduct();
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.queryProduct();
    },
  },
  created() {
    this.loadChannelFilterPreference();
    this.wareList();
    this.whList();
    this.whHoldList();
    this.listOrderType();
    this.listChannel();
    this.deliverUser();
    this.importedUser();
    this.listContainer();
    this.listPlaceOder();
    this.getEndPortList();
    this.topDe(this.ruleForm.topDeclare);
    this.listTag();
    if (this.$route.query.orderNo) {
      this.CopyOrderlist();
    }
    // 查价快速下单预填:渠道/FBA/邮编/国家（费用快照禁止从 URL 注入，改走查价页 addQuick）
    const q = this.$route.query;
    if (q.channelId) { this.ruleForm.topChannel = Number(q.channelId); }
    if (q.wareCode) { this.ruleForm.wareCode = q.wareCode; }
    if (q.zip) { this.ruleForm.addzip = q.zip; }
    if (q.country) { this.ruleForm.country = q.country; }
    this.quoteFeeList = [];
  },
  watch:{
    "ruleForm.master_userArr": {
      handler: function(val) {
        this.qty = 0;
        this.totalValue = 0;
        if (!this.ruleForm.order_user || this.ruleForm.order_user.length === 0) {
          return;
        }
        const first = this.ruleForm.order_user[0];
        first.ctn = 0;
        first.kg = 0;
        first.cbm = 0;
        for (const i in val) {
          this.qty += Number(val[i].qty);
          this.totalValue += Number(val[i].totalValue);
          first.ctn += Number(val[i].ctn);
          first.kg += Number(val[i].kg);
          first.cbm += Number(val[i].cbm);
        }
        this.totalValue = this.totalValue.toFixed(2);
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-input__inner{
  border-radius: 0;
}
/deep/.el-button.is-disabled.el-button--text{
  background:#f00 !important;
}
.grid-content{
  width: 100%;
  color: rgb(2, 2, 2);
  background: #40ff73;
  border-radius: 0;
}
/deep/.el-col{
  padding: 0 !important;
}
.orderby {
  width: auto;
  min-width: 1000px;
}
.last-defaults-banner {
  margin: 12px 20px 0;
}
/deep/ .last-defaults-banner .el-alert__description {
  margin-top: 0;
}
/deep/.el-card__body {
  padding: 0px;
  .el-steps {
    margin-top: 20px;
  }
}
.clearfix {
  text-align: left;
  margin-left: -10px;
  display: flex;
  b,
  i {
    font-size: 14px;
  }
  i {
    margin-right: 5px;
  }
  .el-button {
    margin-left: 20px;
  }
}
/deep/.activeOne {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 0px;
  margin-top: 20px;
  .el-form-item {
    width: 100%;
    margin-bottom: 0;
    .el-date-editor {
      width: 100% !important;
      max-width: 100%;
    }
    .el-select,
    .el-cascader,
    .el-input {
      width: 100%;
    }
  }
  .top {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    align-items: start;
    column-gap: 16px;
    row-gap: 12px;
    margin-top: 12px;
    .top-input {
      display: flex;
      align-items: flex-start;
      width: auto;
      min-width: 0;
      box-sizing: border-box;
      &.top-input--wide {
        grid-column: span 4;
        max-width: none;
      }
    }
    .lable {
      flex: 0 0 96px;
      width: 96px;
      margin: 0;
      padding-right: 8px;
      box-sizing: border-box;
      font-size: 13px;
      font-weight: bold;
      text-align: right;
      line-height: 32px;
      white-space: nowrap;
    }
    .field-control {
      flex: 1;
      min-width: 0;
      width: auto;
    }
    .field-hint-icon {
      margin: 0 2px;
      color: #909399;
      cursor: pointer;
      font-size: 14px;
      vertical-align: middle;
      &:hover {
        color: #409eff;
      }
    }
  }
  .place-group {
    .field-extra--line {
      margin: 8px 0 0;
      padding-left: 96px;
      box-sizing: border-box;
      font-size: 12px;
      color: #606266;
      line-height: 18px;
      white-space: nowrap;
    }
  }
  .channel-toolbar {
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding: 8px 12px 8px 0;
    background: #f7f8fa;
    border: 1px solid #ebeef5;
    box-sizing: border-box;
    .lable {
      flex: 0 0 96px;
      width: 96px;
      margin: 0;
      padding-right: 8px;
      box-sizing: border-box;
      font-size: 13px;
      font-weight: bold;
      text-align: right;
      line-height: 28px;
      white-space: nowrap;
      color: #606266;
    }
    .channel-chips {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px 12px;
      min-height: 28px;
      flex: 1;
      min-width: 0;
    }
    .channel-filter-hint {
      font-size: 12px;
      color: #909399;
      line-height: 28px;
    }
    .channel-filter-country {
      width: 140px;
    }
    .el-radio-button__inner {
      padding: 5px 10px;
    }
  }
  .radio {
    margin-top: 20px;
    .radio-bar {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 8px 12px 8px 0;
      background: #f7f8fa;
      border: 1px solid #ebeef5;
      box-sizing: border-box;
      .lable {
        line-height: 28px;
        color: #606266;
      }
    }
    .radio-body {
      margin-top: 12px;
    }
    .radio-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      column-gap: 16px;
      row-gap: 12px;
    }
    .radio-row {
      display: flex;
      align-items: center;
      min-width: 0;
      &.radio-row--wide {
        grid-column: span 4;
        align-items: flex-start;
        .lable {
          line-height: 32px;
        }
      }
      .field-control {
        flex: 1;
        min-width: 0;
        &.field-control--sm {
          flex: 0 0 240px;
          max-width: 240px;
        }
      }
      .el-form-item {
        display: block;
        margin: 0;
        width: 100%;
      }
      .country {
        width: 100%;
      }
      .radio-addr {
        flex: 1;
        min-width: 0;
        margin-left: 8px;
        color: #909399;
        font-size: 12px;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .lable {
      flex: 0 0 96px;
      width: 96px;
      margin: 0;
      padding-right: 8px;
      box-sizing: border-box;
      font-size: 13px;
      font-weight: bold;
      text-align: right;
      line-height: 32px;
    }
    .el-radio-group {
      margin-left: 0;
      line-height: 32px;
    }
  }
  .upload-demo {
    width: auto;
    float: left;
    .el-upload-list {
      width: auto;
    }
  }
  .product {
    margin-top: 30px;
  }
  .subScribe {
    margin-top: 25px;
    width: 60%;
  }
}
.field-hint-text {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #606266;
}
/deep/.activeTwo {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 0px;
  margin-top: 20px;
  .switch {
    margin-top: 20px;
    display: flex;
    .el-switch + .el-switch {
      margin-left: 30px;
    }
    .sw_cent {
      width: 120px;
      display: flex;
      line-height: 20px;
      .label {
        width: 50px;
      }
    }
  }
  .take {
    margin-top: 20px;
    .take-cent {
      div {
        margin-top: 10px;
      }
      span {
        font-size: 13px;
        width: 80px;
        text-align: right;
        display: inline-block;
      }
      .el-input {
        width: 200px;
        margin-left: 20px;
      }
      .el-date-editor {
        margin-left: 20px;
        .el-input {
          width: 200px !important;
        }
      }
      .el-textarea {
        width: 30%;
        margin-left: 20px;
      }
      .take-time{
        position: relative;
        .el-icon-time{
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
  .insurance {
    margin-top: 20px;
    span {
      font-size: 13px;
      width: 80px;
      text-align: right;
      display: inline-block;
    }
    .el-input {
      width: 200px;
      margin-left: 20px;
      margin-right: 10px;
    }
    .el-tooltip {
      width: 22px;
      border-radius: 50%;
    }
  }
  .remake {
    margin-top: 20px;
    .span {
      display: inline-block;
      font-size: 13px;
      width: 60px;
      text-align: right;
    }
    .el-input {
      display: inline-block;
      width: 80%;
      margin-left: 20px;
    }
    .tag {
      margin-left: 20px;
      margin-top: 10px;
      cursor: pointer;
      .el-tag + .el-tag {
        margin-left: 10px;
      }
    }
  }
}
/deep/.activeThree {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 0px;
  margin-top: 20px;
  div {
    margin-top: 20px;
  }
}
// /deep/a {
//   color: #fff;
// }
table.gridtable {
  width: 720px;
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
  .el-input {
    width: 100px;
    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0;
    }
  }
}
table.gridtable th {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ddd;
  background-color: #ffffff;
  .th {
    width: 100px;
    display: inline-block;
  }
}
table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ddd;
  background-color: #ffffff;
}
.el-select-dropdown {
  min-width: 200px !important;
}
.bitian{
  font: 14px sans-serif;color:red
}
.el-input-number--small{
  width: 90px;
}
.tips{
  padding: 10px 0;
  font-weight: 600;
  text-align: left;
  span{
    margin-right: 20px;
  }
}
.red{
  color: #ff0000;
}
</style>